// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1DFC5","boxTitle":"Qualiphy_boxTitle__2B8h-","box":"Qualiphy_box__3yr89","toggleWrap":"Qualiphy_toggleWrap__3hXcH"};